import { render, staticRenderFns } from "./event_registration.vue?vue&type=template&id=6f21bbba&"
import script from "./event_registration.vue?vue&type=script&lang=js&"
export * from "./event_registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports